import { COLORS } from 'app/constants'
import BigNumber from 'bignumber.js'
import React from 'react'
import { Text } from 'styles/reactnative'
import { useIndexPrice } from '../../hooks/trade/indexprice'

const RealtimePnlPriceSum = ({ sum, pricelist = [], style = {} }: any) => {
	let price = 0
	let pnlprice = 0
	let sumpnlprice = 0
	const { data, mutate, getPrice } = useIndexPrice(
		pricelist?.[0]?.exchange_pairs_id || 2
	)

	pricelist?.map((item: any) => {
		const currentprice = getPrice(item?.exchange_pairs_id)
		if (!item?.exchange_pairs_id) {
			mutate()
		}

		if (item?.long_short == 'L') {
			pnlprice = BigNumber(currentprice).minus(item?.avgprice).toNumber()
		} else {
			pnlprice = BigNumber(item?.avgprice).minus(currentprice).toNumber()
		}
		sumpnlprice = BigNumber(sumpnlprice)
			.plus(BigNumber(pnlprice).multipliedBy(item?.amount))
			.toNumber()
	})

	return (
		<Text
			style={{
				justifyContent: 'flex-end',
				color: BigNumber(sumpnlprice || 0)
					.plus(sum || 0)
					.isGreaterThan(0)
					? COLORS.lightGreen
					: BigNumber(sumpnlprice || 0)
							.plus(sum || 0)
							.isEqualTo(0)
					? 'black'
					: COLORS.lightRed,

				...style,
			}}>
			{BigNumber(sumpnlprice || 0)
				.plus(sum || 0)
				.isGreaterThan(0)
				? '+'
				: ''}
			{BigNumber(sumpnlprice || 0)
				.plus(sum || 0)
				?.toFormat(0)}
		</Text>
	)
}

export default React.memo(RealtimePnlPriceSum)
